import { Header } from 'components/Header';
import { Footer } from 'components/Footer';

export function NotFound() {
  return (
    <div>
      <Header />
      NotFound
      <Footer />
    </div>
  );
}
